import { render, staticRenderFns } from "./usermessageinfo.vue?vue&type=template&id=e8a7bcac&scoped=true"
import script from "./usermessageinfo.vue?vue&type=script&lang=js"
export * from "./usermessageinfo.vue?vue&type=script&lang=js"
import style0 from "./usermessageinfo.vue?vue&type=style&index=0&id=e8a7bcac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a7bcac",
  null
  
)

export default component.exports